<mat-chip-list>
  <mat-chip *ngIf="hasProcessingStatus(item)" size="sm" class="processing-status">
    <div class="processing-chip-text-box">
      <span>{{ 'alpr.export.status.inProgress' | t | uppercase }}</span>
    </div>
  </mat-chip>

  <mat-chip *ngIf="item.status === LprExportStatus.COMPLETE" size="sm" class="complete-status">
    <div class="complete-chip-text-box">
      <span>{{ 'alpr.export.status.complete' | t | uppercase }}</span>
    </div>
  </mat-chip>

  <mat-chip *ngIf="item.status === LprExportStatus.FAILED" size="sm" class="failed-status">
    <div class="failed-chip-text-box">
      <span>{{ 'alpr.export.status.failed' | t | uppercase }}</span>
    </div>
  </mat-chip>

  <span class="warning">
    <sn-icon
      *ngIf="hasErrors"
      fontSet="fa-solid"
      fontIcon="fa-triangle-exclamation"
      [class.error-icon]="true"
      [class.warning-icon]="false"
      [matTooltip]="getErrors"
      matTooltipClass="wide-multiline-tooltip"
    ></sn-icon>
  </span>
</mat-chip-list>
